export const RETURNS_INTAKE_STATUS_LABELS: Record<string, string> = {
  OPEN: 'ABIERTA',
  CLOSED: 'CERRADA',
};

export const RETURNS_INTAKE_STATUS_CLASSES: Record<string, string> = {
  OPEN: 'bg-green-100 text-green-800',
  CLOSED: 'bg-red-100 text-red-800',
};

export const COMPLIANCE_STATUS_CLASSES: Record<string, string> = {
  UNEXPECTED_RETURN_DELIVERED: 'bg-red-100 text-red-800',
  RETURNED_CANCELLED: 'bg-orange-100 text-orange-800',
  DELIVERED_DELAYED: 'bg-orange-100 text-orange-800',
  UNEXPECTED_RETURN: 'bg-red-100 text-red-800',
  DELIVERED_OK: 'bg-green-100 text-green-800',
  RETURNED: 'bg-orange-100 text-orange-800',
  PENDING: 'bg-yellow-100 text-yellow-800',
  NOT_REPORTED: 'bg-red-100 text-red-800',
};

export const DEFAULT_STATUS_CLASS = 'bg-gray-100 text-gray-800';

